<template>
    <div>
        <v-dialog
            persistent
            v-model="dialog"
            :width="ModalType === 'sleep' ? '800px' : '550px'"
        >
            <!-- SECTION IF  SUCCESS  -->
            <v-card class="pa-6" v-if="ModalType === 'success'">
                <v-card-title class="text-center">
                    <div class="success-animation">
                        <svg
                            class="checkmark"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 52 52"
                        >
                            <circle
                                class="checkmark__circle"
                                cx="26"
                                cy="26"
                                r="25"
                                fill="none"
                            />
                            <path
                                class="checkmark__check"
                                fill="none"
                                d="M14.1 27.2l7.1 7.2 16.7-16.8"
                            />
                        </svg>
                    </div>
                </v-card-title>
                <v-card-text class="text-center mt-8">
                    <p class="successMsg">Inativado com sucesso!</p>
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                    <v-btn
                        v-on:click.native="handleCancel"
                        text
                        color="success"
                        class="text-capitalize"
                        >Fechar</v-btn
                    >
                </v-card-actions>
            </v-card>

            <!-- SECTION IF USER WANTS TO PUT PRODUCT TO SLEEP -->
            <v-card
                class="grey lighten-5"
                v-if="ModalType === 'sleep'"
                min-height="450px"
            >
                <v-card-title class="pt-8 white mb-2">
                    <p v-if="step === 1" class="successMsgs">
                        Selecionar datas inativo
                    </p>
                    <p v-if="step === 2" class="successMsgs">
                        Confirmar Informações
                    </p>
                </v-card-title>
                <v-card-text class="d-flex mb-4 pr-10 pl-10 justify-center">
                    <stepper
                        color="#2E8B57"
                        :selectedStep="step"
                        :items="stepperItems"
                    />
                </v-card-text>
                <v-card-text class="pr-10 pl-10">
                    <v-form
                        ref="form"
                        v-if="step === 1"
                        class="justify-center d-flex"
                    >
                        <TimeField
                            color="#0077c8"
                            placeholder="00/00/0000"
                            :cols="5"
                            class="ml-2"
                            outerLabel="Data de Soneca"
                            @input="handledate_nap"
                            :rules="napRules"
                            :errormsg="erromsg"
                            icon="bi bi-calendar-day"
                        />
                    </v-form>

                    <Table
                        v-if="step === 2"
                        :headers="headers"
                        :items="sleepItems"
                    />
                </v-card-text>
                <v-card-actions class="d-flex justify-end pb-12 pr-10">
                    <div>
                        <Button
                            :label="step === 1 ? 'Cancelar' : 'Voltar'"
                            type="secondary"
                            height="40px"
                            class="mr-4"
                            style="border-radius: 3px"
                            width="100px"
                            v-on:click.native="handleGoBack"
                        />
                        <Button
                            :label="step === 2 ? 'Salvar' : 'Proximo'"
                            height="40px"
                            style="border-radius: 3px"
                            width="100px"
                            v-on:click.native="handleNext"
                            :loading="loading"
                        />
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Button from '@/components/Button/Button'
import Table from '../Tables/SimpleTable.vue'
import TimeField from '@/components/Inputs/TimeField.vue'
import moment from 'moment'

import stepper from '@/components/Stepper/stepper'

export default {
    name: 'DeleteModal',
    props: ['ModalType', 'dialog', 'loading', 'sleepItems'],
    components: {
        Button,
        stepper,
        Table,
        TimeField
    },
    data() {
        return {
            step: 1,
            nap: '',
            erromsg: '',
            stepperItems: [
                { id: 1, label: 'Datas', icon: 'bi bi-calendar-date' },
                { id: 2, label: 'Confirmar', icon: 'bi bi-calendar2-check' }
            ],
            napRules: [
                v => (v && !!v.trim()) || 'Data é obrigatório',
                v =>
                    this.formatDateISO(v) >=
                        this.formatDateISO(
                            moment(new Date(), 'DD/MM/YYYY').format(
                                'DD/MM/YYYY'
                            )
                        ) || 'Data de Soneca não pode ser menor que hoje',
                v => {
                    let data = this.formatDateISO(
                        moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY')
                    )
                    data.setDate(data.getDate() + 15)
                    return (
                        data > this.formatDateISO(v) ||
                        'Data de Soneca não pode ser superior a 15 dias da data de hoje'
                    )
                }
            ],
            headers: [
                {
                    text: 'Data Soneca',
                    value: 'date_nap',
                    align: 'center'
                },
                {
                    text: 'Descrição',
                    value: 'product.name',
                    align: 'center'
                },
                {
                    text: 'Filial',
                    value: 'branch.name',
                    align: 'center'
                },
                {
                    text: 'Estoque',
                    value: 'current_stock',
                    align: 'center'
                },
                {
                    text: '% Erro',
                    value: 'error_percentage',
                    align: 'center'
                }
            ]
        }
    },
    methods: {
        handleCancel() {
            this.$emit('Cancel')
            this.reset()
        },
        handleSubmit() {
            this.$emit('Submit')
            this.reset()
        },
        formatDateISO(date) {
            if (!date) return
            var [day, month, year] = date.split('/')
            return new Date(`${year}-${month}-${day} 00:00:00`)
        },
        handleNext() {
            if (this.step === 1) {
                if (this.$refs.form.validate()) {
                    this.step = 2

                    this.sleepItems.map(item => {
                        item.date_nap = new Date(
                            this.nap
                        ).toLocaleDateString('pt-BR', { timeZone: 'UTC' })
                    })
                }
            } else {
                this.$emit('Submit', this.sleepItems)
                this.reset()
            }
        },
        handleGoBack() {
            if (this.step === 1) {
                this.$emit('Cancel')
                this.reset()
            } else {
                this.step = 1
            }
        },
        handledate_nap(date) {
            this.nap = date
        },
        reset() {
            this.step = 1
            this.nap = ''
        }
    }
}
</script>
<style scoped>
.checkmark {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke: #4bb71b;
    stroke-miterlimit: 10;
    box-shadow: inset 0px 0px 0px #4bb71b;
    animation: fill 0.4s ease-in-out 0.4s forwards,
        scale 0.3s ease-in-out 0.9s both;
    position: relative;
    top: 5px;
    right: 5px;
    margin: 0 auto;
}
.checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: #4bb71b;
    fill: #fff;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}

@keyframes scale {
    0%,
    100% {
        transform: none;
    }

    50% {
        transform: scale3d(1.1, 1.1, 1);
    }
}

@keyframes fill {
    100% {
        box-shadow: inset 0px 0px 0px 30px #4bb71b;
    }
}
.successMsg {
    font-family: Inter !important;
    font-size: 25px;
    font-weight: 800px !important;
}
.successMsgs {
    font-family: Inter !important;
    font-size: 25px;
    font-weight: 800px !important;
    color: #2e8b57;
}
.msgdelete {
    font-family: Inter !important;
    font-size: 16px;
}
</style>
